import { getPriceCardColumns } from "./PriceCard.config";

import PriceCard from "./PriceCard";

const PriceCardContainer = ({
  totalApartments,
  totalParkings,
  items,
}: {
  totalApartments: number;
  totalParkings: number;
  items: any[];
}) => {
  const columns = getPriceCardColumns({ totalApartments, totalParkings });

  return <PriceCard items={items} columns={columns} />;
};

export default PriceCardContainer;
